export enum USER_TYPE {
  EXTERNAL_INSURED = 'external-insured'
}
